module.exports = __webpack_public_path__ + "img/banner-1-site.98b3fae1.png";